import { render, staticRenderFns } from "./boyd-legal.vue?vue&type=template&id=0c0dd9fa&scoped=true&"
import script from "./boyd-legal.vue?vue&type=script&lang=js&"
export * from "./boyd-legal.vue?vue&type=script&lang=js&"
import style0 from "./boyd-legal.vue?vue&type=style&index=0&id=0c0dd9fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0dd9fa",
  null
  
)

export default component.exports